import axios from "axios";
// const BASE_URL = "http://localhost:3333";
const BASE_URL = "http://152.42.176.5";

export default axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "multipart/form-data" },
  withCredentials: true,
});
